import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemStock\GetItemStockForItemController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockForItemController.php
* @route '/api/item/{item}/stock'
*/
const GetItemStockForItemController = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemStockForItemController.url(args, options),
    method: 'get',
})

GetItemStockForItemController.definition = {
    methods: ["get","head"],
    url: '/api/item/{item}/stock',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockForItemController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockForItemController.php
* @route '/api/item/{item}/stock'
*/
GetItemStockForItemController.url = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: args.item,
    }

    return GetItemStockForItemController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockForItemController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockForItemController.php
* @route '/api/item/{item}/stock'
*/
GetItemStockForItemController.get = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemStockForItemController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockForItemController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockForItemController.php
* @route '/api/item/{item}/stock'
*/
GetItemStockForItemController.head = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemStockForItemController.url(args, options),
    method: 'head',
})

export default GetItemStockForItemController